import React, { CSSProperties, ReactElement, ReactNode } from 'react'
import { Link } from 'react-router-dom'

export interface IResultTableRowProps {
  title: string
  value: ReactNode
  className?: string
  style?: CSSProperties
  link?: string
}
function ResultTableRow({
  title,
  value,
  className,
  style,
  link,
}: IResultTableRowProps): ReactElement {
  const withLink = link ? <Link to={link}>{value}</Link> : value

  return (
    <tr className={className}>
      <th>{title}</th>

      <td style={style}>{withLink}</td>
    </tr>
  )
}
export default ResultTableRow
